import { ShopperAgentCooldownConfigSchema } from "@redotech/redo-model/shopper-agent/cooldown-config";
import * as z from "zod/v4";

export const updateShopperAgentCooldown = {
  name: "updateShopperAgentCooldown" as const,
  input: z.object({
    cooldownConfig: ShopperAgentCooldownConfigSchema.nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
